// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test_fTpna { 
  position: absolute;
  background-color: var( --color-white );
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/group/search/actions/MobileSearchSettings.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV","sourcesContent":[".test { \n  position: absolute;\n  background-color: var( --color-white );\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"test": `test_fTpna`
};
export default ___CSS_LOADER_EXPORT___;
